/* Validation Rules For Login Form */
export function LoginRules() {
  return {
    usernameRules: usernameRules,
    passwordRules: passwordRules
  };
}

/* Validation Rules For Category Form */
export function CategoryFormRules() {
  return {
    categoryNameRules: nameRules,
    codeRules: codeRules,
    descriptionRules: descriptionRules
  };
}

export function BrandFormRules() {
  return {
    brandNameRules: nameRules,
    codeRules: codeRules,
    descriptionRules: descriptionRules
  };
}

/* Validation Rules For Unit Form */
export function UnitFormRules() {
  return {
    unitNameRules: nameRules,
    codeRules: codeRules,
    descriptionRules: descriptionRules
  };
}

/* Validation Rules For Product Group Form */
export function ProductGroupFormRules() {
  return {
    productGroupNameRules: nameRules,
    codeRules: codeRules,
    descriptionRules: descriptionRules
  };
}

/* Validation Rules For Product Form */
export function ProductFormRules() {
  return {
    productNameRules: nameRules,
    codeRules: codeRules,
    colorRules: colorRules,
    descriptionRules: descriptionRules,
    brandRules: brandRules,
    categoryRules: categoryRules,
    barcodeRules: barcodeRules,
    factorRules: factorRules,
    unitRules: unitRules,
    unitCostRules: unitCostRules,
    sellingPriceRules: sellingPriceRules,
    currencyRules: currencyRules,
    buyingPriceRules: buyingPriceRules,
    wholesalePriceRules: wholesalePriceRules,
    reorderQtyRules: reorderQtyRules
  };
}


export function WarehouseFormRules() {
  return {
    warehouseNameRules: nameRules,
    codeRules: codeRules,
    locationRules: locationRules,
    descriptionRules: descriptionRules
  };
}

export function StockTransferFormRules() {
  return {
    issueDateRules: issueDateRules,
    descriptionRules: descriptionRules,
    fromWarehouseRules: fromWarehouseRules,
    toWarehouseRules: toWarehouseRules,
    productNameRules: productNameRules,
    unitRules: unitRules,
    statusRules: statusRules,
    qtyRules: qtyRules,
    codeRules: codeRules
  };
}

export function StockInFormRules() {
  return {
    warehouseRules: warehouseRules,
    poNoRules: poNoRules,
    issueDateRules: issueDateRules,
    descriptionRules: descriptionRules,
    productNameRules: nameRules,
    unitCostRules: unitCostRules,
    sellingPriceRules: sellingPriceRules,
    qtyRules: qtyRules,
    unitRules: unitRules,
    remarkRules: descriptionRules,
    statusRules: statusRules,
    codeRules: codeRules
  }
}

export function StockAdjustmentFormRules() {
  return {
    issueDateRules: issueDateRules,
    descriptionRules: descriptionRules,
    warehouseRules: warehouseRules,
    statusRules: statusRules,
    codeRules: codeRules
  }
}

export function SaleFormRules() {
  return {
    qtyRules: qtyRules,
    customerIdRules: customerIdRules,
    issueDateRules: issueDateRules,
    remarkRules: remarkRules,
    discountAmountRules: discountAmountRules,
    receivedAmountRules: receivedAmountRules
  }
}

export function WholeSaleFormRules() {
  return {
    qtyRules: qtyRules,
    sellingPriceRules: sellingPriceRules,
    wholesalePriceRules: wholesalePriceRules,
    customerIdRules: customerIdRules,
    issueDateRules: issueDateRules,
    deliveryInfoRules: deliveryInfoRules,
    remarkRules: remarkRules,
    discountAmountRules: discountAmountRules,
    depositeAmountRules: depositeAmountRules
  }
}

export function CreditLevelFormRules() {
  return {
    creditLevelNameRules: nameRules,
    periodDaysRules: periodDaysRules,
    descriptionRules: descriptionRules
  }
}

export function PurchaseOrderFormRules() {
  return {
    issueDateRules: issueDateRules,
    supplierRules: supplierRules,
    currencyRules: currencyRules,
    warehouseRules: warehouseRules,
    statusRules: statusRules,
    descriptionRules: descriptionRules,
    codeRules: codeRules,
    nameRules: nameRules,
    unitRules: unitRules,
    qtyRules: qtyRules,
    unitCostRules: unitCostRules,
    sellingPriceRules: sellingPriceRules,
    remarkRules: descriptionRules
  }
}

export function CustomerFormRules() {
  return {
    nameRules: nameRules,
    codeRules: codeRules,
    addressRules: addressRules,
    phoneNoRules: phoneNoRules,
    emailRules: emailRules,
    creditLevelRules: creditLevelRules
  }
}

export function SupplierFormRules() {
  return {
    companyNameRules: nameRules,
    addressRules: addressRules,
    phoneRules: phoneNoRules,
    emailRules: emailRules,
    contactPersonRules: nameRules
  }
}

export function PriceModelRules() {
  return {
    priceModelRules: nameRules,
    descriptionRules: descriptionRules,
    productNameRules: nameRules,
    unitRules: unitRules,
    sellingPriceRules: sellingPriceRules,
    codeRules: codeRules
  }
}

export function SaleReturnFormRules() {
  return {
    invoiceNoRules: invoiceNoRules,
    qtyRules: returnQtyRules,
  }
}
export function CreditCashFlowFormRules() {
  return {
    payAmountRules: payAmountRules,
    descriptionRules: descriptionRules
  }
}

export function DiscountFormRules() {
  return {
    nameRules: nameRules,
    percentageRules: percentageRules,
    descriptionRules: descriptionRules,
    discountTypeRules: discountTypeRules
  }
}

export function CardFormRules() {
  return {
    cardNoRules: cardNoRules,
    descriptionRules: descriptionRules,
    shopRules: shopRules
  };
}

export function CashNoteFormRules() {
  return {
    cashNoteNameRules: nameRules,
    cashNoteValueRules: valueRules,
    currencyCodeRules: currencyRules,
    descriptionRules: descriptionRules
  };
}

export function DenominationFormRules() {
  return {
    issueDateRules: issueDateRules,
    shopRules: shopRules,
    typeRules: typeRules,
    currencyRules: currencyRules,
    descriptionRules: descriptionRules,
    kPayAmountRules: kPayAmountRules,
    bankTransferRules: bankTransferAmountRules,
    statusRules: statusRules,
    qtyRules: cashNoteQtyRules
  }
}

export function ShopFormRules() {
  return {
    nameRules: nameRules,
    codeRules: codeRules,
    cityRuels: cityRules,
    townshipRules: townshipRules,
    phoneNoRules: phoneNoRules,
    addressRules: addressRules,
    warehouseRules: warehouseRules,
  }
}

export function CounterFormRules() {
  return {
    codeRules: codeRules,
    nameRules: nameRules,
    shopRules: shopRules,
    descriptionRules: descriptionRules,
  }
}

/* Validation Rules */
let usernameRules = [v => !!v || "Username is required"];

let cashNoteQtyRules = [
  v => {
    const pattern = /^[0-9]+$/;
    return pattern.test(v) || "Invalid qty.";
  }
];

let passwordRules = [
  v => !!v || "Password is required",
  v =>
    (v && v.length > 6) || "Password length must be greater than 6 characters"
];

let descriptionRules = [
  v => v.length <= 255 || "Description must be less than 255 characters"
];

let colorRules = [
  v => v.length <= 20 || "Color Code must be less than 20 characters"
];

let remarkRules = [
  v => v.length <= 255 || "Remark must be less than 255 characters"
];

let nameRules = [
  v => !!v || "Name is required",
  v => (v && v.length <= 100) || "Name must be less than 100 characters"
];

let codeRules = [
  v => !!v || "Code is required",
  v => (v && v.length <= 20) || "Code must be less than 20 characters"
];

let locationRules = [
  v => !!v || "Location is required",
  v => (v && v.length <= 100) || "Location must be less than 100 characters"
];

let brandRules = [v => !!v || "Please select the brand"];

let categoryRules = [v => !!v || "Please select the category"];

let barcodeRules = [
  v => !!v || "Barcode is required",
  v =>
    (v && v.length <= 100) || "Barcode length must be less than 100 characters",
  v => {
    const pattern = /^[A-Z0-9]+$/;
    return pattern.test(v) || "Invalid barcode.";
  }
];

let factorRules = [
  v => !!v || "Factor is required",
  v => (v && v < 10000) || "Factor must not be greater than 9999",
  v => {
    const pattern = /^[0-9]+$/;
    return pattern.test(v) || "Invalid factor.";
  }
];

let unitRules = [v => !!v || "Please select the unit"];

let unitCostRules = [
  v => !!v || "Unit cost is required",
  v => (v && v < 10000000) || "Selling price must not be greater than 9999999",
  v => {
    const pattern = /^\d+(\.\d{1,2})*$/;
    return pattern.test(v) || "Invalid unit cost.";
  }
];
let sellingPriceRules = [
  v => !!v || "Selling price is required",
  v => (v && v < 10000000) || "Selling price must not be greater than 9999999",
  v => {
    const pattern = /^\d+(\.\d{1,2})*$/;
    return pattern.test(v) || "Invalid selling price.";
  }
];

let discountAmountRules = [
  v => (v < 10000000) || "Discount amount must not be greater than 9999999",
  v => {
    const pattern = /^\d+(\.\d{1,2})*$/;
    return pattern.test(v) || "Invalid discount amount.";
  }
];

let receivedAmountRules = function (payType, netAmount) {
  const checkMaxLimit = v => (v < 10000000) || "Received amount must not be greater than 9999999";
  const checkFormat = v => {
    const pattern = /^\d+(\.\d{1,2})*$/;
    return pattern.test(v) || "Invalid received amount.";
  };
  const checkCreditLimit = v => (v <= parseFloat(netAmount)) || "Received Amount must not be greater than net amount.";
  const checkCashLimit = v => (v >= parseFloat(netAmount)) || "Received Amount must not be less than net amount.";

  return payType === "CASH" ? [checkFormat, checkCashLimit, checkMaxLimit] : [checkFormat, checkCreditLimit];
}

let depositeAmountRules = function (netAmount) {
  return [
    v => v <= parseFloat(netAmount) || 'Deposit must not be greater than Net Amount',
    v => {
      const pattern = /^\d+(\.\d{1,2})*$/;
      return pattern.test(v) || 'Invalid deposite amount.';
    }
  ];
};

let payAmountRules = [
  v => !!v || "Pay Amount is required",
  v => (v && v < 10000000000) || "Pay Amount must not be greater than 9999999999",
  v => {
    const pattern = /^\d+(\.\d{1,2})*$/;
    return pattern.test(v) || "Invalid pay amount.";
  }
];

let issueDateRules = [v => !!v || "Issue date is required."];

let fromWarehouseRules = [v => !!v || "From warehouse is required."];

let supplierRules = [v => !!v || "Please choose the supplier."];

let currencyRules = [v => !!v || "Please choose the currency."];

let toWarehouseRules = [v => !!v || "To warehouse is required."];

let statusRules = [v => !!v || "Please choose the status."];

let productNameRules = [v => !!v || "Please choose the product name."];

let returnQtyRules = [
  v => (v >= 0 && v < 10000000) || "Qty length must not be greater than 7",
  v => {
    const pattern = /^[0-9]+$/;
    return pattern.test(v) || "Invalid qty.";
  }
];

let qtyRules = [
  v => !!v || "Qty is required",
  v => (v && v < 10000000) || "Qty length must not be greater than 7",
  v => {
    const pattern = /^[0-9]+$/;
    return pattern.test(v) || "Invalid qty.";
  }
];

let reorderQtyRules = [
  v => {
    const pattern = /^[0-9]+$/;
    return pattern.test(v) || "Invalid Reorder level.";
  },
  v => (v >= 0 && v < 10000000) || "Reorder level length must not be greater than 7",
 
];

let percentageRules = [
  v => !!v || "Percent is required",
  v => (v && v < 101) || "Percent must not be greater than 100",
  v => {
    const pattern = /^[0-9]+$/;
    return pattern.test(v) || "Invalid percentage.";
  }
];

let periodDaysRules = [
  v => !!v || "Period Days is required",
  v => (v && v < 100000) || "Period Days length must not be greater than 5.",
  v => {
    const pattern = /^[0-9]+$/;
    return pattern.test(v) || "Invalid Period Days.";
  }
];

let warehouseRules = [v => !!v || "Please select the warehouse"];

let poNoRules = [
  v => !!v || "Po No is required.",
  v => (v && v.length <= 50) || "Po No must be less than 50 characters"];

let addressRules = [
  v => v.length <= 255 || "Address must be less than 255 characters."
];

let phoneNoRules = [
  v => !!v || "PhoneNo is required.",
  v => v.length <= 50 || "PhoneNo must be less than 50 characters."
];

let emailRules = [
  v => {
    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return pattern.test(v) || 'Invalid e-mail.'
  }
];

let creditLevelRules = [v => !!v || "Please select credit level."];

let customerIdRules = [v => !!v || "Please select customer."];

let deliveryInfoRules = [v => !!v || "Delivery Info is required"];

let invoiceNoRules = [v => !!v || "Invoice No. is required"];

let shopRules = [v => !!v || "Shop is required."];

let cardNoRules = [v => !!v || "Card No is required."];

let buyingPriceRules = [
  v => !!v || "Buy Price is required",
  v => (v && v < 10000000) || "Buy Price must not be greater than 9999999",
  v => {
    const pattern = /^\d+(\.\d{1,2})*$/;
    return pattern.test(v) || "Invalid buying price.";
  }
];

let valueRules = [
  v => !!v || "Value is required",
  v => {
    const pattern = /^[0-9]+$/;
    return pattern.test(v) || "Invalid value.";
  }
];

let typeRules = [v => !!v || "Please choose the type."];

let kPayAmountRules = [
  v => (v < 1000000000000000) || "K Pay amount must not be greater than 999999999999999",
  v => {
    const pattern = /^\d+(\.\d{1,2})*$/;
    return pattern.test(v) || "Invalid k pay amount.";
  }
];

let bankTransferAmountRules = [
  v => (v < 1000000000000000) || "Bank transfer amount must not be greater than 999999999999999",
  v => {
    const pattern = /^\d+(\.\d{1,2})*$/;
    return pattern.test(v) || "Invalid bank transfer amount.";
  }
];

let wholesalePriceRules = [
  v => !!v || "Wholesale price is required",
  v => (v && v < 10000000) || "Wholesale price must not be greater than 9999999",
  v => {
    const pattern = /^\d+(\.\d{1,2})*$/;
    return pattern.test(v) || "Invalid wholesale price.";
  }
];

let discountTypeRules = [v => !!v || "Please choose the discount type."];

let cityRules = [v => !!v || "Please select the city"];

let townshipRules = [v => !!v || "Please select the township"];